export const firebaseConfig = {
    apiKey: "AIzaSyAxsIgXAPIm3dWvF-y4JuZxwj5HQ55Pnk4",
    authDomain: "yeti2020-4e2ff.firebaseapp.com",
    databaseURL: "https://yeti2020-4e2ff.firebaseio.com",
    projectId: "yeti2020-4e2ff",
    storageBucket: "yeti2020-4e2ff.appspot.com",
    messagingSenderId: "912701048498",
    appId: "1:912701048498:web:14248d5300fa5d1f366bab",
    measurementId: "G-8L9TJLFCLG"
};
